import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { initializeCapacitor, addSafeAreaStyles } from './utils/capacitor.ts';
import './index.css';
import './styles/camera-scanner.css';

// Initialize Capacitor for mobile app
initializeCapacitor();
addSafeAreaStyles();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
